import React, { useEffect } from "react";
import { func } from "prop-types";
import LightBox from "components/shared/LightBox";

const CalendlyWidget = ({ openCalendly }) => {
  useEffect(() => {
    const head = document.querySelector("head");
    const script = document.createElement("script");
    script.setAttribute(
      "src",
      "https://assets.calendly.com/assets/external/widget.js"
    );
    head.appendChild(script);
  }, []);

  return (
    <LightBox open={openCalendly}>
      <div
        className="calendly-inline-widget"
        data-url="https://calendly.com/supercarers-experts/vitality?utm_source=calendly&utm_campaign=vitality%20talk%20to%20a%20care%20expert"
        style={{ width: "100vw", height: "100%" }}
      />
    </LightBox>
  );
};

CalendlyWidget.propTypes = {
  openCalendly: func.isRequired
};

export default CalendlyWidget;
